import PropTypes from 'prop-types';
import React, { Component } from 'react';

class Gallery extends Component {
    constructor () {
        super();
    }

    renderGallery () {
        const { images } = this.props;

        if (!images) return;

        const gallery = images.map((obj, i) => {
            return (
                <article className="6u 12u$(xsmall) work-item" key={i}>
                    <a
                        className="image fit thumb"
                        href={obj.url}
                        target="_blank"
                    >
                        <img src={obj.thumbnail} />
                    </a>

                    <h3>
                        <a
                            href={obj.url}
                            target="_blank"
                        >
                            {obj.caption}
                        </a>
                    </h3>
                    <p>{obj.description}</p>
                </article>
            );
        });

        return (
            <div className="row">
                <div className="row">
                    {gallery[0]}
                    {gallery[1]}
                </div>
                <div className="row">
                    {gallery[2]}
                    {gallery[3]}
                </div>
                <div className="row">
                    {gallery[4]}
                    {gallery[5]}
                </div>
            </div>
        );
    }
    render () {
        return (
            <div>
                {this.renderGallery()}
            </div>
        );
    }
}

Gallery.displayName = 'Gallery';
Gallery.propTypes = {
    images: PropTypes.array
};

export default Gallery;